var youbora = require('youboralib')
var manifest = require('../manifest.json')
require('youbora-adapter-ima')

youbora.adapters.NexPlayer = youbora.StandardAdapter.extend({
  constructor: function (player, tag) {
    this.tag = tag
    youbora.adapters.NexPlayer.__super__.constructor.call(this, player)
  },

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    return this.player.player_.videoElement_.playbackRate
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    if (this.player.player_ && this.player.player_.videoElement_) {
      return this.player.player_.videoElement_.webkitDroppedFrameCount
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var trackInfo = this.player.getCurrentTrack()
    if (trackInfo) {
      return trackInfo.bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    var trackInfo = this.player.getCurrentTrack()
    if (trackInfo) {
      return youbora.Util.buildRenditionString(trackInfo.width, trackInfo.height, trackInfo.bitrate)
    }
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive()
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.player_.URL
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'NexPlayer'
  },

  registerListeners: function () {
    this.monitorPlayhead(true, false)

    this.references = []
    this.references['ended'] = this.endedListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['play'] = this.playListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['seeked'] = this.seekedListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['loadstart'] = this.adAdapterListener.bind(this)
    /*     'abort': null,
         'canplay': null,
         'canplaythrough': null,
         'durationchange': null,
         'emptied': null,
         'encrypted': null,
         'interruptbegin': null,
         'interruptend': null,
         'loadeddata': null,
         'loadedmetadata': null,
         'loadstart': null,
         'mozaudioavailable': null,
         'progress': null,
         'ratechange': null,
         'stalled': null,
         'suspend': null,
         'timeupdate': null,
         'volumechange': null,
         'waiting': null */
    // Register listeners
    for (var key in this.references) {
      this.tag.addEventListener(key, this.references[key])
    }
  },

  unregisterListeners: function () {
    this.monitor.stop()
    if (this.tag && this.references) {
      for (var key in this.references) {
        this.tag.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  adAdapterListener: function () {
    if (this.plugin.getAdsAdapter()) this.plugin.removeAdsAdapter()
    var adsAdapter = new youbora.adapters.Ima(null)
    adsAdapter.getPosition = function (e) {
      if (this.plugin.getAdapter().getDuration() < this.plugin.getAdapter().getPlayhead() + 1) {
        return 'post'
      }
      if (this.plugin.getAdapter().flags.isJoined) {
        return 'mid'
      }
      return 'pre'
    }
    adsAdapter.setPlayer(this.player.adManager().getAdObject())
    this.plugin.setAdsAdapter(adsAdapter)
    this.plugin.getAdsAdapter().getPlayhead = function () {
      if (!this.flags.isJoined) return 0
      return this.player.currentAd.getDuration() - this.player.getRemainingTime()
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    if (this.flags.isBuffering) {
      this.fireBufferEnd()
    } else {
      this.fireSeekBegin()
    }
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    if (!this.player.player_.videoElement_.paused) {
      this.fireSeekEnd()
    }
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
}

)

module.exports = youbora.adapters.NexPlayer
